import React, {useEffect, useRef, useState} from 'react';
import SidebarHeader from "./SidebarHeader.jsx";
import SidebarLinks from "./SidebarLinks.jsx";
import {Trans} from "react-i18next";

const isProduction = import.meta.env.MODE === 'production';

function Sidebar({sidebarOpen, setSidebarOpen}) {
    const trigger = useRef(null);
    const sidebar = useRef(null);

    const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
    const [sidebarExpanded, setSidebarExpanded] = useState(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true');

    const storedExampleVisible = localStorage.getItem('example-visible');
    const [exampleScreensVisible, setExampleScreensVisible] = useState(storedExampleVisible === null ? false : storedExampleVisible === 'true');

    // close on click outside
    useEffect(() => {
        const clickHandler = ({target}) => {
            if (!sidebar.current || !trigger.current) return;
            if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return;
            setSidebarOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({keyCode}) => {
            if (!sidebarOpen || keyCode !== 27) return;
            setSidebarOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    useEffect(() => {
        localStorage.setItem('sidebar-expanded', sidebarExpanded ? 'true' : 'false');
        if (sidebarExpanded) {
            document.querySelector('body').classList.add('sidebar-expanded');
        } else {
            document.querySelector('body').classList.remove('sidebar-expanded');
        }
    }, [sidebarExpanded]);

    useEffect(() => {
        localStorage.setItem('example-visible', exampleScreensVisible ? 'true' : 'false');
    }, [exampleScreensVisible]);

    return (
        <div className="min-w-fit">
            {/* Sidebar backdrop (mobile only) */}
            <div
                className={`fixed inset-0 bg-slate-900/30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
                    sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
                aria-hidden="true"
            ></div>

            {/* Sidebar */}
            <div
                id="sidebar"
                ref={sidebar}
                className={`flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-[100dvh] overflow-y-scroll lg:overflow-y-auto no-scrollbar w-[270px] lg:w-20 lg:sidebar-expanded:!w-[270px] 2xl:!w-[270px] shrink-0 bg-white dark:bg-gray-800 shadow-sm rounded-r-2xl p-4 transition-all duration-200 ease-in-out ${
                    sidebarOpen ? 'translate-x-0' : '-translate-x-[270px]'
                }`}
            >
                <SidebarHeader
                    buttonTrigger={trigger}
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />

                <SidebarLinks setSidebarExpanded={setSidebarExpanded}/>


                {/* Expand / collapse button */}
                <div className="pt-3 mt-auto flex justify-between items-center w-full gap-3">

                    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs lg:hidden lg:sidebar-expanded:flex 2xl:flex">
                        <a href={'https://datixo.com/documents/vseobecne-obchodni-podminky.pdf'} target={'_blank'} className={'text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300'}>
                            <Trans i18nKey="sidebar.tos-link" />
                        </a>
                    </div>

                    <div className="px-3 py-2 hidden lg:inline-flex 2xl:hidden">
                        <button
                            className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400 transition-colors"
                            onClick={() => setSidebarExpanded(!sidebarExpanded)}
                        >
                            <span className="sr-only">Expand / collapse sidebar</span>
                            <svg className="shrink-0 fill-current text-gray-400 dark:text-gray-500 sidebar-expanded:rotate-180" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                <path d="M15 16a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v14a1 1 0 0 1-1 1ZM8.586 7H1a1 1 0 1 0 0 2h7.586l-2.793 2.793a1 1 0 1 0 1.414 1.414l4.5-4.5A.997.997 0 0 0 12 8.01M11.924 7.617a.997.997 0 0 0-.217-.324l-4.5-4.5a1 1 0 0 0-1.414 1.414L8.586 7M12 7.99a.996.996 0 0 0-.076-.373Z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
